/**
 * CRM (Fachmodul "crm"): Aktivitaeten und Wiedervorlagen.
 *
 * Eine Aktivitaet ist ein Eintrag in der Kontakthistorie eines Partners -
 * ein Anruf, ein Besuch, eine E-Mail oder eine Notiz. Traegt sie eine
 * Wiedervorlage (Faelligkeitstag), ist sie ein offener Punkt fuer den
 * zustaendigen Benutzer, bis er sie erledigt. Ein reiner Vermerk ohne
 * Wiedervorlage entsteht direkt als erledigt.
 *
 * Wer die Aktivitaet erfasst hat und wer zustaendig ist, sind getrennte
 * Angaben: Die Sachbearbeitung nimmt den Anruf entgegen und stellt die
 * Wiedervorlage dem Aussendienst ein.
 */
export const CRM_ACTIVITY_KINDS = ['call', 'visit', 'email', 'note'];
export const CRM_ACTIVITY_KIND_LABELS = {
    call: 'Anruf',
    visit: 'Besuch',
    email: 'E-Mail',
    note: 'Notiz',
};
export const CRM_ACTIVITY_STATUSES = ['open', 'done'];
export const CRM_ACTIVITY_STATUS_LABELS = {
    open: 'Offen',
    done: 'Erledigt',
};
//# sourceMappingURL=crm.js.map